import { computed } from "vue"
import { useStore } from "vuex"

const useAuth = () => {
    const store = useStore()

    const login = async (user) => {
        const res = store.dispatch('auth/singIn', user)
        return res
    }

    const checkAuthStatus = async () => {
        const res = store.dispatch('auth/checkAuthentication')
        return res
    }

    const checkPermission = async (permission) => {
        const userPermissions = store.getters['auth/userPermissions']
        return userPermissions.indexOf(permission) > -1
    }

    const logout = () => {
        store.commit('auth/logout')
    }

    return {
        login,
        checkAuthStatus,
        logout,
        authStatus: computed(() => store.getters['auth/currentStatus']),
        fullName: computed(() => store.getters['auth/fullName']),
        username: computed(() => store.getters['auth/username']),
        employee: computed(() => store.getters['auth/employeeData']),
        staffer: computed(() => store.getters['auth/stafferData']),
        user: computed(() => store.getters['auth/userData']),
        getSubsidiaries: computed(() => store.getters['auth/subsidiaries']),
        checkPermission
    }
}

export default useAuth